import { v4 as uuid } from 'uuid'
import { CartItemTypes } from './cartSlice'
export const cartItems = [
    {
        cartItemId: uuid(),
        id: 0,
        type: CartItemTypes.Course,
    },
    {
        cartItemId: uuid(),
        id: 1,
        type: CartItemTypes.Class,
        invites: [],
    },
    {
        cartItemId: uuid(),
        id: 5,
        type: CartItemTypes.Plan,
    },
]
